import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";

export const EMPTY_SHIP = { name: "", contact: "", mobile: "", address: "", city: "", state: "", pin: "", gstin: "", instructions: "", default: false };

export function ShipToEditor({ ships, setShips }) {
  const setShip = (i, k, v) => setShips((ss) => ss.map((s, j) => (j === i ? { ...s, [k]: v } : s)));
  return (
    <div className="border border-border rounded-md p-3 space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Shipping Addresses ({ships.length})</p>
        <Button size="sm" variant="outline" onClick={() => setShips((ss) => [...ss, { ...EMPTY_SHIP, _k: crypto.randomUUID() }])} data-testid="cf-add-shipto"><Plus className="w-4 h-4 mr-1" /> Add Shipping Address</Button>
      </div>
      {ships.map((s, i) => (
        <div key={s._k} className="border border-border/60 rounded-md p-3 grid grid-cols-2 md:grid-cols-4 gap-2" data-testid={`cf-shipto-${i}`}>
          <Input placeholder="Address name" value={s.name} onChange={(e) => setShip(i, "name", e.target.value)} data-testid={`cf-shipto-name-${i}`} />
          <Input placeholder="Contact person" value={s.contact} onChange={(e) => setShip(i, "contact", e.target.value)} />
          <Input placeholder="Mobile" value={s.mobile} onChange={(e) => setShip(i, "mobile", e.target.value)} />
          <Input placeholder="GSTIN" value={s.gstin} onChange={(e) => setShip(i, "gstin", e.target.value)} />
          <div className="col-span-2"><Input placeholder="Address" value={s.address} onChange={(e) => setShip(i, "address", e.target.value)} /></div>
          <Input placeholder="City" value={s.city} onChange={(e) => setShip(i, "city", e.target.value)} />
          <Input placeholder="State" value={s.state} onChange={(e) => setShip(i, "state", e.target.value)} />
          <Input placeholder="PIN" value={s.pin} onChange={(e) => setShip(i, "pin", e.target.value)} />
          <label className="flex items-center gap-2 text-xs col-span-2">
            <input type="checkbox" className="w-4 h-4 accent-primary" checked={s.default} onChange={(e) => setShip(i, "default", e.target.checked)} data-testid={`cf-shipto-default-${i}`} />
            Default shipping address
          </label>
          <Button size="sm" variant="ghost" className="justify-self-end" onClick={() => setShips((ss) => ss.filter((_, j) => j !== i))} data-testid={`cf-shipto-remove-${i}`}><Trash2 className="w-4 h-4 text-signal-red" /></Button>
        </div>
      ))}
    </div>
  );
}
